import { IAppState } from '../../redux';

export const selectCadastralNumbers = (state: IAppState) => {
  const { buildingCadastralNumber, cadastralNumber } = state.offer;

  return { buildingCadastralNumber, cadastralNumber };
};
